const headers = {
  name: "Billing Returns",
  navigate: {
    path: [
      {
        name: "Returns",
        path: "/app/billing/returns",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
